import { Modal, Button } from 'antd'
import styled from 'styled-components'
import { SPACING, TYPOGRAPHY } from '../../../styles/theme'

interface StoryboardConfirmModalProps {
  isOpen: boolean
  onClose: () => void
  onConfirm: () => void
  ideaLabel: string
}

const DescriptionText = styled.p`
  color: var(--color-text-primary);
  font-size: ${TYPOGRAPHY.body.fontSize};
  margin: 0 0 ${SPACING.md} 0;
  line-height: 1.6;
`

const SecondaryText = styled.p`
  color: var(--color-text-secondary);
  font-size: ${TYPOGRAPHY.caption.fontSize};
  margin: 0;
  line-height: 1.5;
`

export function StoryboardConfirmModal({
  isOpen,
  onClose,
  onConfirm,
  ideaLabel,
}: StoryboardConfirmModalProps) {
  return (
    <Modal
      title={`Generate Storyboard: ${ideaLabel}`}
      open={isOpen}
      onCancel={onClose}
      centered
      width={480}
      destroyOnHidden={true}
      footer={[
        <Button key="cancel" onClick={onClose}>
          Cancel
        </Button>,
        <Button key="confirm" type="primary" onClick={onConfirm}>
          Generate Storyboard
        </Button>,
      ]}
    >
      <DescriptionText>
        A 4-panel illustrated story built from this idea and its ancestors — venture context, unmet
        need to be done, and parent ideas.
      </DescriptionText>
      <SecondaryText>Uses one storyboard credit.</SecondaryText>
    </Modal>
  )
}
